import { Link } from 'react-router-dom';
import { Waves, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border/20 text-foreground py-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="p-2.5 rounded-xl bg-primary/10">
                <Waves className="h-6 w-6 text-primary" />
              </div>
              <span className="font-serif text-2xl font-semibold">
                Swell Breaks
              </span>
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Discover your perfect surf destination. Handpicked and surf-tested.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-6">Explore</h4>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link to="/destinations" className="inline-block py-2.5 hover:text-foreground transition-colors">Destinations</Link></li>
              <li><Link to="/trip-planner" className="inline-block py-2.5 hover:text-foreground transition-colors">Trip Planner</Link></li>
              <li><Link to="/media" className="inline-block py-2.5 hover:text-foreground transition-colors">Media</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-6">Company</h4>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link to="/privacy-policy" className="inline-block py-2.5 hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="inline-block py-2.5 hover:text-foreground transition-colors">Terms and Conditions</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-serif text-lg font-semibold mb-6">Connect</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/swell_breaks/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="inline-flex items-center justify-center p-3 sm:p-3.5 rounded-xl bg-muted/30 hover:bg-muted/50 transition-colors cursor-pointer min-w-[48px] min-h-[48px]"
              >
                <Instagram className="h-5 w-5 pointer-events-none" />
              </a>
              <a
                href="https://www.tiktok.com/@swell.breaks"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="inline-flex items-center justify-center p-3 sm:p-3.5 rounded-xl bg-muted/30 hover:bg-muted/50 transition-colors cursor-pointer min-w-[48px] min-h-[48px]"
              >
                <svg
                  className="h-5 w-5 pointer-events-none"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.07A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border/20 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Swell Breaks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
